
        import {css} from 'lit-element';   
        export default css`:host{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;height:100%}`;
    